import axios from 'axios';

export default {
  async index() {
    const { data } = await axios.get(`${window.addiesaas.url}/api/setting`);
    return data;
  }
}
